import { Outlet } from "react-router-dom";
import Header from "../components/Header/Header";

import "./MainLayout.css";

export default function MainLayout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
    </>
  );
}
